import { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';

/**
 * Input de telefone com máscara obrigatória no formato (DD) 99999-9999
 * O hífen é fixo e não pode ser removido.
 */
export default function PhoneInput({ value, onChange, className, ...props }) {
  const [displayValue, setDisplayValue] = useState('');

  // Formata o telefone no padrão (DD) 99999-9999
  const formatPhone = (rawValue) => {
    // Remove tudo que não é número
    const digits = rawValue.replace(/\D/g, '');
    
    // Limita a 11 dígitos (2 DDD + 9 número)
    const limitedDigits = digits.slice(0, 11);
    
    let formatted = '';
    
    if (limitedDigits.length > 0) {
      formatted = '(' + limitedDigits.slice(0, 2);
    }
    if (limitedDigits.length >= 2) {
      formatted += ') ';
    }
    if (limitedDigits.length > 2) {
      formatted += limitedDigits.slice(2, 7);
    }
    if (limitedDigits.length > 7) {
      formatted += '-' + limitedDigits.slice(7, 11);
    }
    
    return formatted;
  };

  // Sincroniza valor externo com display
  useEffect(() => {
    if (value) {
      setDisplayValue(formatPhone(value));
    } else {
      setDisplayValue('');
    }
  }, [value]);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const formatted = formatPhone(inputValue);
    
    setDisplayValue(formatted);
    
    // Passa o valor formatado para o componente pai
    if (onChange) {
      onChange(formatted);
    }
  };

  // Valida se o telefone está completo
  const isComplete = displayValue.length === 15; // (DD) 99999-9999 = 15 chars
  
  return (
    <Input
      type="tel"
      value={displayValue}
      onChange={handleChange}
      placeholder="(DD) 99999-9999"
      maxLength={15}
      className={`${className} ${displayValue && !isComplete ? 'border-amber-500' : ''}`}
      {...props}
    />
  );
}
